<template>
    <div class="scenes-box">
        <p class="img-box">
            <img v-if="imgUrl" :src="imgUrl" alt="img" />
            <img v-else :src="$images.material.default" alt="img" />
        </p>
        <div class="title-box">
            <p class="title">
                <span class="name">当前背景：</span>
                <span class="value">{{imgName}}</span>
            </p>
            <div class="btns-box">
                <p
                    v-if="imgUrl"
                    class="btn btn2"
                    @click="handleSetDiplay"
                >{{imgVisible?'隐藏':'显示'}}</p>
                <p
                    class="btn"
                    @click="handleSelectImage"
                >选择背景图</p>
            </div>
        </div>
    </div>
</template>

<script>
    import {mapActions} from 'vuex'
    export default {
        name: "BackgroundBox",
        props: {
            form: Object
        },
        computed: {
            imgUrl() {
                let value = ''
                try {
                    value = this.$store.state.editGameConfig.scenesData.override.background
                }catch (e) {
                    console.log('获取图片失败==>', value)
                }
                return value
            },
            imgName() {
                let value = ''
                try {
                    value = this.$store.state.editGameConfig.scenesData.override.backgroundName
                }catch (e) {
                    console.log('获取图片名称失败==>', value)
                }
                return value
            },
            imgVisible() {
                let value = ''
                try {
                    value = this.$store.state.editGameConfig.scenesData.override.backgroundVisible
                }catch (e) {
                    console.log('获取图片名称失败==>', value)
                }
                return value
            }
        },
        watch: {
            form:{
                handler(vl){
                    this.newForm = vl
                },
                deep: true,
                immediate: true
            },
            newForm:{
                handler(vl){
                    this.$emit('update:form',vl)
                },
                deep: true,
                immediate: true
            }
        },
        data () {
            return {
                newForm: this.form
            }
        },
        methods: {
            ...mapActions(['setOperationQueue']),
            // 通知cocos侧显示或隐藏
            handleSetDiplay(){
                const backgroundVisible = !(this.$store.state.editGameConfig.scenesData.override && this.$store.state.editGameConfig.scenesData.override.backgroundVisible)
                const operationQueue = [
                    {
                        operation: 'REPLACE',
                        path: '/scenesData/override/backgroundVisible',
                        data: backgroundVisible
                    }
                ]
                this.setOperationQueue(operationQueue)
            },
            // 选中游戏背景图
            handleSelectImage() {
                this.$toWebMessage({
                    type: 'EditResource',
                    value: {type: "image", value: this.$store.state.editGameConfig.scenesData.categoryId},
                    callback: { type:'EditGameConfig', path: '/scenesData/override', operation: 'REPLACE', flag: 'background'}
                })
            }
        }
    }
</script>

<style lang="scss" scoped>
.scenes-box{
    padding: 20px;
    display: flex;
    flex-direction: row;
    justify-content: flex-start;

    .img-box{
        width: 243px;
        height: 137px;
        background-color: #eee;
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
        border-radius: 4px;
        overflow: hidden;

        img{
            max-width: 100%;
            max-height: 100%;
            object-fit: contain;
        }
    }
    .title-box{
        display: flex;
        margin-left: 20px;
        flex-direction: column;
        justify-content: space-between;

        .title{
            font-size:14px;
            font-weight:400;
            color:rgba(144,147,153,1);
            line-height:20px;
            margin-left: 10px;
            display: flex;
            flex-direction: column;

            .value{
                font-size:16px;
                font-weight:500;
                color:rgba(51,51,51,1);
                line-height:22px;
                margin-top: 6px;
            }
        }
        .btn{
            width:88px;
            text-align: center;
            height:34px;
            line-height: 34px;
            background:rgba(255, 120, 56,1);
            border: 1px solid rgba(255, 120, 56,1);
            border-radius:4px;
            font-size:14px;
            font-weight:500;
            color:rgba(255,255,255,1);
            cursor: pointer;

            &:hover {
                opacity: .8;
            }
            &:active{
                opacity: .6;
            }

            &.btn2{
                margin-bottom: 6px;
                background-color: white;
                color: #323232;
                border: 1px solid #DCDFE6;
            }
        }
    }
}
</style>
